export { default } from './B2bHome';
